import { useState } from 'react';
import toast from 'react-hot-toast';

// Reemplaza a window.prompt() para pedir un motivo (reimpresión, anulación,
// rechazo de reimpresión) con el mismo estilo visual del resto de la app.
export default function ModalMotivo({ titulo, ayuda, requerido = true, textoConfirmar = 'Confirmar', onCancelar, onConfirmar }) {
  const [motivo, setMotivo] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function handleConfirmar() {
    if (requerido && !motivo.trim()) {
      toast.error('Indica el motivo antes de continuar.');
      return;
    }
    setEnviando(true);
    try {
      await onConfirmar(motivo.trim());
    } finally {
      setEnviando(false);
    }
  }

  return (
    <>
      <div className="modal-fondo no-imprimir" onClick={onCancelar} />
      <div className="modal-ventana modal-ventana-angosta no-imprimir">
        <h4>{titulo}</h4>
        {ayuda && <p className="ayuda">{ayuda}</p>}
        <label>Motivo{!requerido && ' (opcional)'}</label>
        <textarea
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          rows={3}
          autoFocus
        />
        <div className="acciones-nuevo-banco">
          <button type="button" className="btn-secundario" onClick={onCancelar} disabled={enviando}>
            Cancelar
          </button>
          <button type="button" className="btn-primary" onClick={handleConfirmar} disabled={enviando}>
            {enviando ? 'Enviando…' : textoConfirmar}
          </button>
        </div>
      </div>
    </>
  );
}
